import type { FlowStep } from '@forq/ui';
import { incomingStatusLabels, type IncomingInvoice, type IncomingInvoiceStatus } from '@forq/finance-data';

const incomingFlowOrder: readonly IncomingInvoiceStatus[] = [
  'captured', 'pre_booked', 'review_requested', 'approved', 'payment_requested', 'payment_released', 'paid',
];
const incomingRank = new Map<IncomingInvoiceStatus, number>(incomingFlowOrder.map((status, index) => [status, index]));

/** Builds the FORQ Flow approval trail (done → current → upcoming; rejected/cancelled terminal). */
export function buildIncomingFlow(invoice: IncomingInvoice): readonly FlowStep[] {
  if (invoice.status === 'cancelled' || invoice.status === 'rejected') {
    const reachedRank = invoice.status === 'rejected' ? (incomingRank.get('review_requested') ?? 0) : 0;
    const steps: FlowStep[] = incomingFlowOrder
      .filter((status) => (incomingRank.get(status) ?? 0) <= reachedRank)
      .map((status) => ({ key: status, label: incomingStatusLabels[status], state: 'done' as const }));
    steps.push({ key: invoice.status, label: incomingStatusLabels[invoice.status], state: 'cancelled' });
    return steps;
  }
  const currentRank = incomingRank.get(invoice.status) ?? 0;
  return incomingFlowOrder.map((status) => {
    const rank = incomingRank.get(status) ?? 0;
    return {
      key: status,
      label: incomingStatusLabels[status],
      state: rank < currentRank ? 'done' : rank === currentRank ? 'current' : 'upcoming',
    };
  });
}
